<template>
  <v-menu v-model="popoverMenu" :close-on-content-click="false" offset-y left nudge-top="5">
    <template v-slot:activator="{ on, attrs }">
      <span v-bind="attrs" v-on="on"></span>
    </template>
    <v-card min-width="500">
      <v-card-text class="pa-3">
        <div v-for="(field, index) in localFields" :key="index">
          <v-text-field
            v-model="field.value"
            :label="field.label"
            outlined
            dense
            hide-details
            class="mt-4 field-width"
            v-if="field.type === 'text'"
            :prepend-inner-icon="field.icon"
          >
          </v-text-field>
          <VueEditor
            v-model="field.value"
            v-if="field.type === 'editor'"
            :editor-toolbar="customToolbar"
            :placeholder="field.label"
            class="mt-4 field-width"
          >
          </VueEditor>
          <div v-if="field.type === 'slider'" class="mt-4 field-width">
            <div class="text-caption mb-2">{{ field.label }}</div>
            <v-slider
              v-model="field.value"
              :min="field.min"
              :max="field.max"
              :step="field.step || 1"
              thumb-label="always"
              hide-details
            ></v-slider>
          </div>
        </div>

        <div class="d-flex justify-space-between mt-2">
          <v-btn small class="normal-case" outlined color="red" @click="closePopover">
            <v-icon left small>mdi-close</v-icon>
            Cancel
          </v-btn>
          <div>
            <v-btn small outlined @click="copyLinkToClipboard" class="mr-2">
              <v-icon left small>mdi-content-copy</v-icon>
              Copy Link
            </v-btn>
            <v-btn
              small
              class="normal-case"
              color="primary"
              @click="saveFormResponse"
              :loading="isLoading"
            >
              <v-icon left small>mdi-content-save</v-icon>
              {{ saveButtonText }}
            </v-btn>
          </div>
        </div>
      </v-card-text>
    </v-card>
  </v-menu>
</template>
<script>
import { VueEditor } from 'vue2-editor'
import { APP_URL } from '@/utils/workforce/constants'

export default {
  components: {
    VueEditor
  },
  data() {
    return {
      popoverMenu: false,
      localFields: [],
      customToolbar: [
        ['bold', 'italic', 'underline', 'strike'],
        ['blockquote', 'code-block'],
        [{ header: 1 }, { header: 2 }],
        [{ list: 'ordered' }, { list: 'bullet' }],
        [{ script: 'sub' }, { script: 'super' }],
        [{ indent: '-1' }, { indent: '+1' }],
        [{ direction: 'rtl' }],
        [{ size: ['small', false, 'large', 'huge'] }],
        [{ header: [1, 2, 3, 4, 5, 6, false] }],
        [{ color: [] }, { background: [] }],
        [{ font: [] }],
        [{ align: [] }],
        ['clean'],
        ['link', 'image', 'video']
      ]
    }
  },
  props: {
    fields: Array,
    saveButtonText: { type: String, default: 'Save' },
    categoryData: { type: Object, default: null }, // Add category data prop
    isLoading: { type: Boolean, default: false }
  },
  watch: {
    fields: {
      handler(newFields) {
        this.localFields = newFields.map((field) => {
          // If this is an editor field and we have category data, pre-fill with the category link
          if (field.type === 'editor' && this.categoryData && this.categoryData._id) {
            // const orgData = this.$storage ? this.$storage.getUniversal('orgData') : null
            // if (orgData && orgData.id) {
            // const link = `${APP_URL[process.env.VUE_APP_ENV]}/open/form/${orgData.id}/${
            //   this.categoryData._id
            // }`
            // const link = `${APP_URL[process.env.VUE_APP_ENV]}/open/form/${orgData.id}`
            const linkHtml = `[LINK]`
            return {
              ...field,
              value: field.value || linkHtml
            }
            // }
          }
          return {
            ...field,
            value: field.value || ''
          }
        })
      },
      immediate: true
    }
  },
  methods: {
    open() {
      this.popoverMenu = true
    },
    closePopover() {
      this.popoverMenu = false
    },
    copyLinkToClipboard() {
      this.$emit('copyShareLink')
    },
    async saveFormResponse() {
      // Emit the updated localFields data
      this.$emit('savePopoverResponse', this.localFields)
    }
  }
}
</script>
<style scoped>
.field-width {
  width: 100%;
  max-width: 500px;
}

.vue2-editor {
  min-height: 150px;
  width: 100%;
  max-width: 500px;
}
</style>
